import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { Fade } from "@progress/kendo-react-animation";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog, Window } from "@progress/kendo-react-dialogs";
import { SvgIcon } from "@progress/kendo-react-common";
import { FlatColorPicker, NumericTextBox, Switch, TextBox } from "@progress/kendo-react-inputs";
import { useLocalization } from "@progress/kendo-react-intl";
import { Avatar, ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import { NotificationGroup, Notification } from "@progress/kendo-react-notification";
import { copyIcon, plusIcon, saveIcon, trashIcon } from "@progress/kendo-svg-icons";
import axios from "axios";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { AccessToken } from "../../../config/AccessToken";
import { loadingPanel } from "../../LoadingPanel";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { TransformComponent, TransformWrapper, useControls } from "react-zoom-pan-pinch";
import { AzureMapComponent } from "../../../pages/AzureMapComponent";
import { currentLocation } from "../../../assets/current-location";
import { useMapDrawingLayer } from "../../useMapDrawingLayer";
type PolygonPoint = {
    x?: number;
    y?: number;
    longitude?: number;
    latitude?: number;
};

type CanvasPolygonPoint = Required<Pick<PolygonPoint, "x" | "y">>;
type GeoPolygonPoint = Required<Pick<PolygonPoint, "longitude" | "latitude">>;

const isCanvasPoint = (point: PolygonPoint): point is CanvasPolygonPoint =>
    typeof point?.x === 'number' && typeof point?.y === 'number';

const isGeoPoint = (point: PolygonPoint): point is GeoPolygonPoint =>
    typeof point?.longitude === 'number' && typeof point?.latitude === 'number';



export const ConfigZones = () => {

    const localizationService = useLocalization();
    let languageId = localStorage.getItem('languageId');
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [instance, accessTokenRequest] = AccessToken();

    const userType = localStorage.getItem('userType');

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<any>(false);
    const [errorMessage, setErrorMessage] = useState<any>('');

    const [zonesList, setZonesList] = useState<any>([])
    const [zonesInfo, setZonesInfo] = useState<any>([])
    const [zoneSelected, setZoneSelected] = useState<any>([])
    const [selectedZoneId, setSelectedZoneId] = useState<number | string | null>(null)
    const [zoneSearchTerm, setZoneSearchTerm] = useState('')
    const [count, setCount] = useState(0)
    const [detailsExpanded, setDetailsExpanded] = useState(true)

    const [zoneName, setZoneName] = useState<any>('')

    const [valueColor, setValueColor] = useState<any>('#ffffff');
    const [toggleColorPicker, setToggleColorPicker] = useState<boolean>(false);

    const [updateZone, setUpdateZone] = useState<boolean>(false);

    const [listMapNames, setListMapNames] = useState([]);
    const [listMaps, setListMaps] = useState([]);
    const [mapName, setMapName] = useState<any>(null);
    const [selectedMap, setSelectedMap] = useState<any>([]);
    const [altitude, setAltitude] = useState<any>(0);

    const [currZonePoints, setCurrZonePoints] = useState<any>(0);
    const [polygonPoints, setPolygonPoints] = useState<PolygonPoint[]>([]);
    const [prefillPolygonVersion, setPrefillPolygonVersion] = useState(0);

    const [showLimitCapacity, setShowLimitCapacity] = useState<any>(false);
    const [limitCapacity, setLimitCapacity] = useState<any>(0);

    const [locationZone, setLocationZone] = useState<any>(true);
    const [internal, setInternal] = useState<any>(false);
    const [isGeo, setIsGeo] = useState<any>(false);

    const [switchShowAllZones, setSwitchShowAllZones] = useState<any>(false);

    const [mapGeoreferenced, setMapGeoreferenced] = useState(false);
    const [noMaps, setNoMaps] = useState<any>(false);
    const [toggleGeoStatic, setToggleGeoStatic] = useState<any>(true);
    const [mapZones, setMapZones] = useState<any[]>([]);

    const [mapImageWidth, setMapImageWidth] = useState<any>(0);
    const [mapImageHeight, setMapImageHeight] = useState<any>(0);
    const [mapImageData, setMapImageData] = useState<string | null>(null);

    const [messageEditEnabled, setMessageEditEnabled] = useState<boolean>(false);


    const [messageSavedZone, setMessageSavedZone] = useState<boolean>(false);
    const [messageDeletedZone, setMessageDeletedZone] = useState<boolean>(false);
    const [messageClonedZone, setMessageClonedZone] = useState<boolean>(false);
    const [messageUpdatedZone, setMessageUpdatedZone] = useState<boolean>(false);


    const mapRefStatic: any = useRef(null);
    const mapRefAzure: any = useRef(null);
    let mapCanvas: any = useRef(null);
    const referenceZonesCanvas: any = useRef(null);
    const zoneCanvas: any = useRef(null);
    const previousSelectedZoneIdRef = useRef<number | string | null>(null);
    const lastSelectedZoneIdRef = useRef<number | string | null>(null);
    const selectionLockZoneIdRef = useRef<number | string | null>(null);
    const hasInitializedSelectionRef = useRef(false);

    const polygonRef: any = useRef<{ reenterEditMode?: () => void; exitEditMode?: () => void } | null>(null);
    const pendingAddVertexRef = useRef(false);
    const [mode, setMode] = useState<"reset" | "polygon" | 'edit'>("reset");
    const [polygonReady, setPolygonReady] = useState(false);
    const [drawingModeEnabled, setDrawingModeEnabled] = useState(false);

    const [contextMenu, setContextMenu] = useState<{ visible: boolean; x: number; y: number; vertexIndex: number | null }>({
        visible: false,
        x: 0,
        y: 0,
        vertexIndex: null,
    });

    const canvasPolygonPoints = useMemo(() => polygonPoints.filter(isCanvasPoint), [polygonPoints]);
    const geoPolygonPoints = useMemo(() => polygonPoints.filter(isGeoPoint), [polygonPoints]);
    const normalizedZoneSearch = zoneSearchTerm.trim().toLowerCase();
    const filteredZonesList = useMemo(() => {
        if (!normalizedZoneSearch) {
            return zonesList;
        }

        return zonesList.filter((zone: any) => {
            const zoneId = String(zone?.id ?? '').toLowerCase();
            const zoneName = String(zone?.name ?? '').toLowerCase();
            return zoneId.includes(normalizedZoneSearch) || zoneName.includes(normalizedZoneSearch);
        });
    }, [zonesList, normalizedZoneSearch]);
    const allowStaticMapPan = !mapGeoreferenced && mode !== 'polygon';

    const clearZoneDrawingState = (clearSelectedZone: boolean) => {
        polygonRef.current?.exitEditMode?.();
        const fabricCanvas = (polygonRef.current as any)?.canvas;
        if (fabricCanvas) {
            fabricCanvas.clear();
        }
        polygonRef.current = null;
        setContextMenu({ visible: false, x: 0, y: 0, vertexIndex: null });
        setPolygonPoints([]);
        setCurrZonePoints(0);
        setPolygonReady(false);
        setPrefillPolygonVersion((prev) => prev + 1);
        if (clearSelectedZone) {
            setZoneSelected([]); // Reset della zona selezionata per triggare il clear in AzureMapComponent
            setSelectedZoneId(null);
        }
        setSwitchShowAllZones(false);

        // Pulisce il canvas per le mappe statiche
        const canvasElement = zoneCanvas.current;
        if (canvasElement) {
            const context = canvasElement.getContext('2d');
            context?.clearRect(0, 0, canvasElement.width, canvasElement.height);
        }

        const referenceElement = referenceZonesCanvas.current;
        if (referenceElement) {
            const refContext = referenceElement.getContext('2d');
            refContext?.clearRect(0, 0, referenceElement.width, referenceElement.height);
        }

        // Pulisce il poligono per le mappe georeferenziate (Azure Maps)
        if (mapGeoreferenced && mapRefAzure.current) {
            // Triggera il reset anche sul componente Azure Maps
            // passando un array vuoto o resettando la zona
            handleAzurePolygonVertices([]);
        }

        setMode('reset');
    };

    const resetZoneDrawing = () => {
        clearZoneDrawingState(true);
    };

    const resetZoneDrawingPreserveSelection = () => {
        clearZoneDrawingState(false);
    };

    const resetMapSelectionForNewZone = () => {
        setMapName(null);
        setSelectedMap(null);
        setMapZones([]);
        setMapGeoreferenced(false);
        setToggleGeoStatic(true);
        localStorage.setItem('mapId', '');
        localStorage.setItem('mapGeoreferenced', JSON.stringify(true));
        localStorage.setItem('onToggleGeoStatic', JSON.stringify(true));

        const staticMapCanvas = mapCanvas.current;
        if (staticMapCanvas) {
            const mapCtx = staticMapCanvas.getContext('2d');
            mapCtx?.clearRect(0, 0, staticMapCanvas.width, staticMapCanvas.height);
            staticMapCanvas.style.backgroundImage = '';
        }

        const zoneOverlayCanvas = zoneCanvas.current;
        if (zoneOverlayCanvas) {
            const zoneCtx = zoneOverlayCanvas.getContext('2d');
            zoneCtx?.clearRect(0, 0, zoneOverlayCanvas.width, zoneOverlayCanvas.height);
        }

        const referenceCanvas = referenceZonesCanvas.current;
        if (referenceCanvas) {
            const referenceCtx = referenceCanvas.getContext('2d');
            referenceCtx?.clearRect(0, 0, referenceCanvas.width, referenceCanvas.height);
        }

        setMapImageData(null);
        setMapImageWidth(0);
        setMapImageHeight(0);
    };

    useMapDrawingLayer({
        canvasRef: zoneCanvas,
        mode,
        polygonRef,
        valueColor,
        initialPolygon: !mapGeoreferenced && canvasPolygonPoints.length >= 3 ? { points: canvasPolygonPoints, color: valueColor } : undefined,
        prefillVersion: prefillPolygonVersion,
        onPolygonComplete: (points) => {
            setPolygonPoints(points);
            setPolygonReady(points.length >= 3);
            setCurrZonePoints(points.length);
        },
        onPolygonEditExit: () => {
            setMode('reset');
        },
        onVertexRightClick: (vertexIndex, vertexPoint) => {
            setContextMenu({
                visible: true,
                x: vertexPoint.x + 10,  // offset
                y: vertexPoint.y - 10,  // offset
                vertexIndex
            });
        }
    });

    useEffect(() => {
        if (!zoneCanvas.current || !polygonRef.current || !polygonReady) return;

        if (mode === 'polygon') {
            polygonRef?.current?.reenterEditMode?.();
            if (pendingAddVertexRef.current) {
                polygonRef.current?.enterAddVertexMode?.();
                pendingAddVertexRef.current = false;
            }
        }

        if (mode === 'reset') {
            polygonRef?.current?.exitEditMode?.();
        }
    }, [mode, polygonReady]);

    useEffect(() => {
        setDrawingModeEnabled(mode === 'polygon');
    }, [mode]);

    useEffect(() => {
        // Nessun auto-reset di switchShowAllZones qui.
        // Il toggle va gestito esplicitamente dall'utente.
    }, [mode]);

    useEffect(() => {
        if (polygonRef.current && polygonRef.current.updateFillColor) {
            polygonRef.current.updateFillColor(valueColor);
        }
    }, [valueColor]);


    useEffect(() => {
        let timer: any;
        if (messageEditEnabled) {
            timer = setTimeout(() => {
                setMessageEditEnabled(false);
            }, 3000);
        }
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [messageEditEnabled]);

    useEffect(() => {
        const handleClickOutside = () => {
            if (contextMenu.visible) {
                setContextMenu({ visible: false, x: 0, y: 0, vertexIndex: null });
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [contextMenu]);

    const removeVertex = () => {
        if (contextMenu.vertexIndex !== null && polygonRef.current) {
            polygonRef.current.removeVertex(contextMenu.vertexIndex);
            setContextMenu({ visible: false, x: 0, y: 0, vertexIndex: null });
        }
    };

    useEffect(() => {
        if (mapCanvas?.current != null) {
            const mapCtx = mapCanvas.current.getContext("2d");
            if (mapCtx != null) {
                void renderMap(selectedMap);
            }
        }
    }, []);

    useEffect(() => {
        getZonesList(true);
    }, []);

    const getZonesList = async (flag: boolean, selectedZoneIdToKeep?: number | string, preferNewestZoneSelection: boolean = false) => {

        setLoading(true);
        const commonOperations = async (accessToken: any) => {

            let languageId = localStorage.getItem('languageId');
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            try {
                const res: any = await axios.get(`${SERVER_URL}/zone/list`, { headers });
                const data = Array.isArray(res?.data?.data) ? res.data.data : [];
                setCount(data.length)

                setZonesList(data)
                setZonesInfo(data)

                if (data.length > 0) {
                    let zoneToKeep: any = null;

                    if (selectedZoneIdToKeep != null) {
                        zoneToKeep = data.find((zone: any) => zone?.id == selectedZoneIdToKeep) ?? null;
                    }

                    if (!zoneToKeep && preferNewestZoneSelection) {
                        zoneToKeep = [...data]
                            .filter((zone: any) => zone?.id != null)
                            .sort((a: any, b: any) => Number(b?.id) - Number(a?.id))[0]
                            ?? data[data.length - 1]
                            ?? null;
                    }

                    const zoneIdForSelection = zoneToKeep?.id ?? selectionLockZoneIdRef.current
                        ?? previousSelectedZoneIdRef.current
                        ?? lastSelectedZoneIdRef.current
                        ?? selectedZoneId
                        ?? zoneSelected?.id;

                    if (!zoneToKeep && zoneIdForSelection != null) {
                        zoneToKeep = data.find((zone: any) => zone?.id == zoneIdForSelection) ?? null;
                    }

                    if (zoneToKeep) {
                        getSelectedZone(zoneToKeep)
                    } else if (flag && zoneIdForSelection == null && !hasInitializedSelectionRef.current) {
                        getSelectedZone(data[0])
                    }
                }
            } catch (error: any) {
                if (error instanceof InteractionRequiredAuthError) {
                    instance.acquireTokenRedirect(accessTokenRequest);
                }
                console.log(error);
            } finally {
                setLoading(false)
            }
        }
        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            await commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                await commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false)
                });
        }
    };

    const rgba2hex = (rgba: any) => {
        return "#" + rgba.replace(/^rgba?\(|\s+|\)$/g, '') // Get's rgba / rgb string values
            .split(',') // splits them at ","
            .filter((string: any, index: any) => index !== 3)
            .map((string: any) => parseFloat(string)) // Converts them to numbers
            .map((number: any, index: any) => index === 3 ? Math.round(number * 255) : number) // Converts alpha to 255 number
            .map((number: any) => number.toString(16)) // Converts numbers to hex
            .map((string: any) => string.length === 1 ? "0" + string : string) // Adds 0 when length of one number is 1
            .join("")
    }

    const convertGeoPointsToCanvasPoints = useCallback((geoPoints: any[] = [], mapInfo?: any) => {
        const canvasWidth = zoneCanvas.current?.width || mapImageWidth || 0;
        const canvasHeight = zoneCanvas.current?.height || mapImageHeight || 0;

        const mapDetails = mapInfo ?? selectedMap;

        if (!canvasWidth || !canvasHeight || !geoPoints.length || !mapDetails) {
            return [];
        }

        const { botLeft, botRight, topLeft } = mapDetails ?? {};
        if (!botLeft || !botRight || !topLeft) {
            return [];
        }

        const lonSpan = Number(botRight?.longitude) - Number(botLeft?.longitude);
        const latSpan = Number(topLeft?.latitude) - Number(botLeft?.latitude);

        if (!lonSpan || !latSpan) {
            return [];
        }

        return geoPoints.map((point: any) => {
            const longitude = Number(point?.longitude ?? point?.x ?? 0);
            const latitude = Number(point?.latitude ?? point?.y ?? 0);

            const x = canvasWidth * (longitude - Number(botLeft?.longitude)) / lonSpan;
            const y = canvasHeight * (Number(topLeft?.latitude) - latitude) / latSpan;

            return { x, y };
        });
    }, [mapImageWidth, mapImageHeight, selectedMap]);

    const resolveStaticCanvasPoints = useCallback((zoneEntry: any, mapInfo?: any, targetCanvas?: HTMLCanvasElement | null) => {
        const rawPoints = Array.isArray(zoneEntry?.points)
            ? zoneEntry.points
            : Array.isArray(zoneEntry?.geoPoints)
                ? zoneEntry.geoPoints
                : [];

        if (!rawPoints.length) {
            return [];
        }

        const canvasWidth = targetCanvas?.width || zoneCanvas.current?.width || mapImageWidth || 0;
        const canvasHeight = targetCanvas?.height || zoneCanvas.current?.height || mapImageHeight || 0;

        const normalizedPoints = rawPoints.map((point: any) => {
                const x = parseFloat(Number(point?.x ?? point?.longitude ?? 0).toFixed(8));
                const y = parseFloat(Number(point?.y ?? point?.latitude ?? 0).toFixed(8));
                return Number.isFinite(x) && Number.isFinite(y) ? { x, y } : null;
            })
            .filter((point: any) => point !== null);

        const allNormalized = normalizedPoints.length === rawPoints.length
            && normalizedPoints.every((point: any) => point.x >= 0 && point.x <= 1 && point.y >= 0 && point.y <= 1);

        if (allNormalized && canvasWidth && canvasHeight) {
            return normalizedPoints.map((point: any) => ({
                x: canvasWidth * point.x,
                y: canvasHeight - (canvasHeight * point.y)
            }));
        }

        const geoConvertedPoints = convertGeoPointsToCanvasPoints(rawPoints, mapInfo);
        if (geoConvertedPoints.length) {
            return geoConvertedPoints;
        }

        return rawPoints
            .map((point: any) => {
                const x = parseFloat(Number(point?.x ?? point?.longitude ?? 0).toFixed(8));
                const y = parseFloat(Number(point?.y ?? point?.latitude ?? 0).toFixed(8));
                return Number.isFinite(x) && Number.isFinite(y) ? { x, y } : null;
            })
            .filter((point: any) => point !== null);
    }, [convertGeoPointsToCanvasPoints, mapImageHeight, mapImageWidth]);

    const getSelectedZone = async (zone: any) => {
        if (!zone) {
            return;
        }

        hasInitializedSelectionRef.current = true;

        if (zone?.id != null) {
            lastSelectedZoneIdRef.current = zone.id;
            if (selectionLockZoneIdRef.current != null && selectionLockZoneIdRef.current == zone.id) {
                selectionLockZoneIdRef.current = null;
            }
            // Lock visual selection immediately to avoid async race conditions.
            setZoneSelected(zone);
            setSelectedZoneId(zone.id);
            // Clear one-shot preservation once a concrete selection is applied.
            previousSelectedZoneIdRef.current = null;
        }

        setSwitchShowAllZones(false);
        const referenceCanvas = referenceZonesCanvas.current;
        if (referenceCanvas) {
            const refCtx = referenceCanvas.getContext('2d');
            refCtx?.clearRect(0, 0, referenceCanvas.width, referenceCanvas.height);
        }
        // Exit edit mode before hydrating the next zone to avoid stale Fabric clears.
        pendingAddVertexRef.current = false;
        setMode('reset');

        const zoneMap = await getMapByZoneId(zone.id);
        const resolvedMap = zoneMap ?? selectedMap;

        if( resolvedMap.georeferenced == 1 && !toggleGeoStatic) {            
            setToggleGeoStatic(true);
            localStorage.setItem('onToggleGeoStatic', JSON.stringify(true));
            setMapGeoreferenced(true);
            localStorage.setItem('mapGeoreferenced', JSON.stringify(true));
        }

        const applyZoneSelection = (zoneData: any, mapDataForZone?: any) => {
            const hydratedZone = {
                id: zoneData?.id ?? zone?.id,
                name: zoneData?.name ?? zone?.name ?? '',
                color: zoneData?.color ?? zone?.color ?? '#ffffff'
            };

            setZoneSelected(zoneData ?? zone);
            setSelectedZoneId(hydratedZone.id ?? null);
            setZonesInfo([hydratedZone]);
            setZoneName(hydratedZone.name);
            setValueColor(hydratedZone.color);
            setLocationZone(zoneData?.isLocation);
            setAltitude(zoneData?.altitude ?? 0);
            setIsGeo(zoneData.isGeoreferenced)

            const capacityValue = zoneData?.capacity ?? 0;
            setLimitCapacity(capacityValue);
            setShowLimitCapacity(capacityValue > 0);

            setInternal(Boolean(zoneData?.isIndoor));

            const rawGeoPoints = zoneData?.geoPoints ?? zoneData?.points ?? [];
            if (Array.isArray(rawGeoPoints) && rawGeoPoints.length) {
                if (mapDataForZone?.georeferenced == 1 && !toggleGeoStatic) {
                    const geoPoints = rawGeoPoints
                        .map((point: any) => ({
                            longitude: parseFloat(Number(point?.longitude ?? point?.x ?? 0).toFixed(8)),
                            latitude: parseFloat(Number(point?.latitude ?? point?.y ?? 0).toFixed(8))
                        }))
                        .filter((point) => Number.isFinite(point.longitude) && Number.isFinite(point.latitude));

                    setPolygonPoints(geoPoints);
                    setPolygonReady(geoPoints.length >= 3);
                    setCurrZonePoints(geoPoints.length);
                } else {
                    const canvasPoints = resolveStaticCanvasPoints({ points: rawGeoPoints }, mapDataForZone, zoneCanvas.current);
                    setPolygonPoints(canvasPoints);
                    setPolygonReady(canvasPoints.length >= 3);
                    setCurrZonePoints(canvasPoints.length);
                    setPrefillPolygonVersion((prev) => prev + 1);

                    // Disegna la zona sulla mappa
                    const canvas = zoneCanvas.current;
                    if (canvas && canvasPoints.length >= 3) {
                        const zoneCtx = canvas.getContext("2d");
                        if (zoneCtx) {
                            zoneCtx.clearRect(0, 0, canvas.width, canvas.height);
                            zoneCtx.beginPath();
                            zoneCtx.fillStyle = zoneData?.color ?? zone?.color ?? '#ffffff';
                            zoneCtx.moveTo(canvasPoints[0].x, canvasPoints[0].y);
                            canvasPoints.forEach((point: any, index: number) => {
                                if (index > 0) {
                                    zoneCtx.lineTo(point.x, point.y);
                                }
                            });
                            zoneCtx.closePath();
                            zoneCtx.globalAlpha = 0.8;
                            zoneCtx.fill();
                            zoneCtx.globalAlpha = 1.0;
                        }
                    }
                }
            } else {
                setPolygonPoints([]);
                setPolygonReady(false);
                setCurrZonePoints(0);
                setPrefillPolygonVersion((prev) => prev + 1);
            }

            setUpdateZone(true);
        };

        applyZoneSelection(zone, resolvedMap);

        const isStaticView = !Boolean(isMapGeoreferencedFlag(resolvedMap?.georeferenced) && toggleGeoStatic);
        if (resolvedMap?.id && isStaticView) {
            await getZoneByMapId(resolvedMap.id, false, resolvedMap, zone.id, false);
        }

    }

    const handleChangeZoneName = (event: any) => {
        setZoneName(event.target.value);
    }

    const handleChangeColor = (event: any) => {
        let color: any = rgba2hex(event.value);
        setValueColor(color);
        setToggleColorPicker(false)
    };

    const showColorPicker = () => {
        setToggleColorPicker(!toggleColorPicker);
    }

    const handleAzurePolygonVertices = useCallback((vertices: Array<{ longitude: number; latitude: number }>) => {
        if (!mapGeoreferenced) {
            return;
        }

        if (!Array.isArray(vertices) || !vertices.length) {
            setPolygonPoints([]);
            setPolygonReady(false);
            setCurrZonePoints(0);
            return;
        }

        const normalizedVertices = vertices.map((point) => ({
            longitude: parseFloat(Number(point.longitude).toFixed(8)),
            latitude: parseFloat(Number(point.latitude).toFixed(8))
        }));

        setPolygonPoints(normalizedVertices);
        setPolygonReady(normalizedVertices.length >= 3);
        setCurrZonePoints(normalizedVertices.length);
    }, [mapGeoreferenced, setCurrZonePoints, setPolygonPoints]);

    const getNormalizedGeoPoints = () => {
        if (!polygonPoints.length) {
            return [];
        }

        if (mapGeoreferenced) {
            if (!geoPolygonPoints.length) {
                return [];
            }

            return geoPolygonPoints.map(({ longitude, latitude }) => ({
                longitude: parseFloat(Number(longitude).toFixed(8)),
                latitude: parseFloat(Number(latitude).toFixed(8))
            }));
        }

        const canvasWidth = mapImageWidth || zoneCanvas.current?.width || 0;
        const canvasHeight = mapImageHeight || zoneCanvas.current?.height || 0;

        if (!canvasWidth || !canvasHeight || !canvasPolygonPoints.length) {
            return [];
        }

        return canvasPolygonPoints.map(({ x, y }) => {
            const lonLeft = Number(selectedMap?.botLeft?.longitude);
            const lonRight = Number(selectedMap?.botRight?.longitude);
            const latTop = Number(selectedMap?.topLeft?.latitude);
            const latBottom = Number(selectedMap?.botLeft?.latitude);

            const longitude = lonLeft + (lonRight - lonLeft) * (x / canvasWidth);
            const latitude = latTop - (latTop - latBottom) * (y / canvasHeight);

            return {
                longitude: parseFloat(longitude.toFixed(8)),
                latitude: parseFloat(latitude.toFixed(8))
            };
        });
    };

    const saveNewZone = async () => {
        setLoading(true);
        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const geoPointsPayload = getNormalizedGeoPoints();
            const params = {
                name: zoneName,
                color: valueColor,
                isLocation: locationZone,
                altitude: altitude,
                capacity: showLimitCapacity ? limitCapacity : 0,
                isGeoreferenced: isGeo,
                isIndoor: internal,
                geoPoints: geoPointsPayload
            };
            try {
                const createResponse = await axios.post(`${SERVER_URL}/zone`, params, { headers })
                const createdZoneId = createResponse?.data?.data?.id
                    ?? createResponse?.data?.id
                    ?? createResponse?.data?.data?.zone?.id
                    ?? null;
                handleChangeZoneName({ target: { value: '' } })
                handleChangeColor({ value: '#ffffff' })
                setValueColor('#ffffff')
                setUpdateZone(false)
                setAltitude(0);
                setLimitCapacity(0);
                setShowLimitCapacity(false);
                setInternal(false);
                setLocationZone(true);
                setIsGeo(false);
                setPolygonPoints([])
                setPrefillPolygonVersion((prev) => prev + 1)
                resetZoneDrawingPreserveSelection()
                resetMapSelectionForNewZone()
                selectionLockZoneIdRef.current = createdZoneId;
                getZonesList(false, createdZoneId ?? undefined, true);
                setMessageSavedZone(true);
                setLoading(false)
                if (!messageSavedZone) {
                    setTimeout(() => {
                        setMessageSavedZone(false);
                    }, 3000);
                }
            } catch (error: any) {
                setError(error);
                if (error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
                setLoading(false)
            }
        }
        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }

    const updateSelectedZone = async (zoneId: any) => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const geoPointsPayload = getNormalizedGeoPoints();
            const params = {
                name: zoneName,
                color: valueColor,
                isLocation: locationZone,
                altitude: altitude,
                capacity: showLimitCapacity ? limitCapacity : 0,
                isGeoreferenced: isGeo,
                isIndoor: internal,
                geoPoints: geoPointsPayload
            };
            try {
                await axios.put(`${SERVER_URL}/zone/${zoneId}`, params, { headers })
                handleChangeZoneName({ target: { value: '' } })
                setUpdateZone(false)
                resetZoneDrawing()
                resetMapSelectionForNewZone()
                getZonesList(true);

                setMessageUpdatedZone(true);
                setLoading(false)
                if (!messageUpdatedZone) {
                    setTimeout(() => {
                        setMessageUpdatedZone(false);
                    }, 3000);
                }

            } catch (error: any) {
                setError(error);
                setErrorMessage(error?.response?.data?.errorMessage)
                setLoading(false)
                if (error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }


    }

    const cloneZone = async (zoneId: any) => {

        setLoading(true);


        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            try {
                await axios.post(`${SERVER_URL}/zone/${zoneId}/copy`, null, { headers })
                setZoneName('');
                handleChangeZoneName({ target: { value: '' } })
                handleChangeColor({ value: '#ffffff' })
                setValueColor('#ffffff')
                setUpdateZone(false)
                getZonesList(true);
                setLoading(false)
                setMessageClonedZone(true);
                if (!messageClonedZone) {
                    setTimeout(() => {
                        setMessageClonedZone(false);
                    }, 3000);
                }
            } catch (error: any) {
                setError(error);
                if (error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
                setLoading(false)
            }
        }
        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }

    const Controls = () => {
        const { zoomIn, zoomOut, resetTransform } = useControls();

        return (
            <div style={{ display: 'flex', zIndex: 0 }}>
                <button
                    className="k-button static-map"
                    title={localizationService.toLanguageString('map.zoom_in', 'NOT_FOUND')}
                    onClick={() => zoomIn()}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                        <path d="M12 5v14" />
                        <path d="M5 12h14" />
                    </svg>
                </button>
                <button
                    className="k-button static-map"
                    title={localizationService.toLanguageString('map.zoom_out', 'NOT_FOUND')}
                    onClick={() => zoomOut()}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                        <path d="M5 12h14" />
                    </svg>
                </button>
                <button
                    className="k-button static-map"
                    title={localizationService.toLanguageString('map.reset_zoom', 'NOT_FOUND')}
                    onClick={() => resetTransform()}
                >
                    <SvgIcon icon={currentLocation} />
                </button>
            </div>
        );
    };

    //getMapList()
    useEffect(() => {
        const getMapList = async () => {

            localStorage.setItem('mapId', '');

            const commonOperations = async (accessToken: any) => {
                try {
                    const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
                    const res = await axios.get(`${SERVER_URL}/map/full/list`, { headers });
                    const data = res?.data.data;

                    if (!data?.length) {
                        setNoMaps(true);
                        setLoading(false);
                        return;
                    }

                    const mapsList = data;
                    const mapNames = data.map((map: any) => map.name);
                    const mainMap = data.find((map: any) => map.main == '1');

                    setListMaps(mapsList);
                    setListMapNames(mapNames);

                    //const currMapSelected = (() => {
                    //    try {
                    //        const parsed = JSON.parse(localStorage.getItem('mapSelected') || 'null');
                    //        return parsed;
                    //    } catch {
                    //        return null;
                    //    }
                    //})();

                    //const fallbackMap =
                    //    (Array.isArray(currMapSelected) && currMapSelected.length > 0 && currMapSelected) ||
                    //    (!Array.isArray(currMapSelected) && typeof currMapSelected === 'object' && currMapSelected) ||
                    //    mainMap ||
                    //    mapsList[0];

                    //const fallbackMapId = fallbackMap?.id ?? '-1';

                    //localStorage.setItem('mapId', JSON.stringify(fallbackMapId));
                    
                    //await changeMap(fallbackMap, mapsList);
                    //getMapById(fallbackMap.id);
                } catch (error) {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                } finally {
                    setLoading(false);
                }
            };


            if (localStorage.getItem('accessToken') != null) {
                let accessToken = localStorage.getItem('accessToken');
                commonOperations(accessToken);
            } else {
                await instance.initialize();
                await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                    let accessToken = accessTokenResponse.accessToken;
                    commonOperations(accessToken);
                })
                    .catch((error: any) => {
                        if (error instanceof InteractionRequiredAuthError) {
                            instance.acquireTokenRedirect(accessTokenRequest);
                        }
                    });
            }
        }
        getMapList()
    }, [])

    const renderMap = async (map: any) => {
        const isMapGeo: boolean = stringToBoolean(localStorage.getItem('mapGeoreferenced'));
        const canvas = mapCanvas.current;

        if (!canvas) return;

        const mapCtx = canvas.getContext("2d");
        if (!mapCtx) return;

        if (isMapGeo) {
            setMapImageData(null);
            setMapGeoreferenced(true);
            return;
        }

        mapCtx.clearRect(0, 0, mapCtx.canvas.width, mapCtx.canvas.height);

        const width = canvas.parentElement?.offsetWidth || 1400;

        const backgroundCanvas = new Image();
        setMapImageData(map?.image ?? null);

        if (!map?.image) return;
        backgroundCanvas.src = `data:image/jpeg;base64, ${map.image}`;

        await new Promise<void>((resolve) => {
            backgroundCanvas.onload = () => {
                const wImg = backgroundCanvas.width;
                const hImg = backgroundCanvas.height;

                const height = width * hImg / wImg;

                canvas.width = zoneCanvas.current.width = width;
                canvas.height = zoneCanvas.current.height = height;

                if (referenceZonesCanvas.current) {
                    referenceZonesCanvas.current.width = width;
                    referenceZonesCanvas.current.height = height;
                    const refCtx = referenceZonesCanvas.current.getContext('2d');
                    refCtx?.clearRect(0, 0, width, height);
                }

                canvas.style.backgroundImage = `url(${backgroundCanvas.src})`;

                mapCtx.drawImage(backgroundCanvas, 0, 0, width, height);

                setMapImageWidth(width);
                setMapImageHeight(height);
                resolve();
            };

            backgroundCanvas.onerror = () => resolve();
        });

        setMapGeoreferenced(false);
    };

    const stringToBoolean = (str: any) => {
        return str?.toLowerCase() === 'true';
    }

    const isMapGeoreferencedFlag = (value: any) => {
        return value === true || value === 1 || value === '1';
    };

    const getStoredGeoTogglePreference = () => {
        const storedToggle = localStorage.getItem('onToggleGeoStatic');

        if (storedToggle == null) {
            return true;
        }

        try {
            return JSON.parse(storedToggle);
        } catch (err) {
            return stringToBoolean(storedToggle);
        }
    };

    const changeMap = async (event: any, mapsList?: any, preserveSelectedZone: boolean = false) => {

        let currMap: any = ''
        if (event?.value != undefined) {
            currMap = event?.value ?? event ?? ''
        } else {
            currMap = event.name ?? event ?? ''
        }

        if (event?.georeferenced != null) {
            event?.georeferenced == 0 ? setMapGeoreferenced(false) : setMapGeoreferenced(true)
        }

        setToggleGeoStatic(true)
        localStorage.setItem('onToggleGeoStatic', JSON.stringify(true));
        setSwitchShowAllZones(false);
        const shouldPreserveSelectedZone = preserveSelectedZone || previousSelectedZoneIdRef.current != null || selectedZoneId != null;
        if (!shouldPreserveSelectedZone) {
            setZoneSelected([]);
            setSelectedZoneId(null);
            setLocationZone(true);
        }
        setPolygonPoints([]);
        setPolygonReady(false);
        setCurrZonePoints(0);

        const currListMaps: any = listMaps.length > 0 ? listMaps : mapsList

        const isMapGeo = currListMaps?.find((map: any) => map.name == currMap)?.georeferenced
        const convertedValue: boolean = isMapGeoreferencedFlag(isMapGeo)
        localStorage.setItem('mapGeoreferenced', JSON.stringify(convertedValue));
        setMapGeoreferenced(convertedValue);

        let mapSelected = currListMaps?.find((map: any) => map.name == currMap)

        const updateMapSelected = mapSelected ?? currListMaps?.find((map: any) => map.id == currMap)

        if (updateMapSelected == null) return


        const mapCtx = mapCanvas?.current?.getContext("2d");
        const mapWidth = mapCanvas?.width ?? mapCanvas?.current?.width
        const mapHeight = mapCanvas?.height ?? mapCanvas?.current?.height
        mapCtx?.clearRect(0, 0, mapWidth, mapHeight)

        const zoneCtx = zoneCanvas?.current?.getContext("2d");
        const zoneWidth = zoneCanvas?.width ?? zoneCanvas?.current?.width
        const zoneHeight = zoneCanvas?.height ?? zoneCanvas?.current?.height
        zoneCtx?.clearRect(0, 0, zoneWidth, zoneHeight)

        setSelectedMap(updateMapSelected)
        setMapName(updateMapSelected.name)

        //localStorage.setItem("mapSelected", JSON.stringify(updateMapSelected))
        localStorage.setItem("mapId", updateMapSelected.id)

        await renderMap(updateMapSelected);
        void getMapById(updateMapSelected?.id); // inizialize the mapCanvas

        const isGeoreferenced = updateMapSelected?.georeferenced == 1 ? true : false
        await getZoneByMapId(updateMapSelected.id, isGeoreferenced, updateMapSelected)

    }

    const getMapById = async (mapId: number) => {

        setLoading(true);

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/map/${mapId}`, { headers })
                .then((res) => {

                    if (res.data == '' || res.data.length == 0) {
                        setLoading(false);
                        return;
                    }

                    const data = res.data.data

                    setAltitude(data.altitude)

                    let infoMapSelected: any = []
                    let botLeft: any = []
                    let topLeft: any = []
                    let botRight: any = []
                    let topRight: any = []

                    infoMapSelected.push(data)
                    botLeft.push(data.botLeft)
                    topLeft.push(data.topLeft)
                    botRight.push(data.botRight)
                    topRight.push(data.topRight)

                    setMapName(data.name)

                    const shouldShowGeoView = Boolean(isMapGeoreferencedFlag(data?.georeferenced) && getStoredGeoTogglePreference());
                    setMapGeoreferenced(shouldShowGeoView);
                    localStorage.setItem('mapGeoreferenced', JSON.stringify(shouldShowGeoView));

                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                });
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }
        setLoading(false);
    }

    const getZoneByMapId = async (mapId: number, isGeoreferenced?: any, mapDetailsOverride?: any, selectedZoneIdOverride?: any, showAllOverride?: boolean) => {

        if (mapId == null || mapId == undefined) {
            return;
        }

        setLoading(true);

        let normalizedGeoref = isGeoreferenced;
        if (normalizedGeoref === 0 || normalizedGeoref === 1) {
            normalizedGeoref = normalizedGeoref === 1;
        }
        const isGeoView = typeof normalizedGeoref === 'boolean' ? normalizedGeoref : Boolean(mapGeoreferenced && toggleGeoStatic);
        const mapDetailsForCanvas = mapDetailsOverride ?? selectedMap;

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };

            try {
                const res = await axios.get(`${SERVER_URL}/zone/bymapid/${mapId}?isGeoreferenced=${isGeoView}`, { headers });
                const data = Array.isArray(res?.data?.data) ? res.data.data : [];
                setMapZones(data);

                const listZones = data ?? [];
                const selectedZoneIdResolved = selectedZoneIdOverride ?? selectedZoneId ?? zoneSelected?.id;
                const selectedZoneData = listZones.find((zone: any) => zone?.id == selectedZoneIdResolved);

                const canvas = zoneCanvas.current;
                if (!canvas) {
                    setLoading(false);
                    return;
                }

                const zoneCtx = canvas.getContext("2d");
                if (!zoneCtx) {
                    setLoading(false);
                    return;
                }

                const referenceCanvas = referenceZonesCanvas.current;
                const referenceCtx = referenceCanvas?.getContext('2d');

                const isEditingStaticCanvas = mode === 'polygon' && !isGeoView;
                if (!isEditingStaticCanvas) {
                    const rawPoints = Array.isArray(selectedZoneData?.points) ? selectedZoneData.points : [];
                    if (!rawPoints.length) {
                        setPolygonPoints([]);
                        setPolygonReady(false);
                        setCurrZonePoints(0);
                    } else if (isGeoView) {
                        setPolygonPoints(rawPoints);
                        setPolygonReady(rawPoints.length >= 3);
                        setCurrZonePoints(rawPoints.length);
                    } else {
                        const canvasPoints = resolveStaticCanvasPoints({ points: rawPoints }, mapDetailsForCanvas, canvas);
                        setPolygonPoints(canvasPoints);
                        setPolygonReady(canvasPoints.length >= 3);
                        setCurrZonePoints(canvasPoints.length);
                    }
                    setPrefillPolygonVersion((prev) => prev + 1);
                }

                const drawZonePolygon = (ctx: CanvasRenderingContext2D, targetCanvas: HTMLCanvasElement, zoneEntry: any, alpha: number) => {
                    const pointsToRender = !isGeoView
                        ? resolveStaticCanvasPoints(zoneEntry, mapDetailsForCanvas, targetCanvas)
                        : convertGeoPointsToCanvasPoints(zoneEntry?.points ?? [], mapDetailsForCanvas);
                    if (pointsToRender.length < 3) {
                        return;
                    }

                    ctx.beginPath();
                    ctx.fillStyle = zoneEntry?.color ?? '#ffffff';
                    ctx.moveTo(pointsToRender[0].x, pointsToRender[0].y);
                    pointsToRender.forEach((point: any, index: number) => {
                        if (index > 0) {
                            ctx.lineTo(point.x, point.y);
                        }
                    });
                    ctx.closePath();
                    ctx.globalAlpha = alpha;
                    ctx.fill();
                    ctx.globalAlpha = 1;
                };

                const shouldShowAllZones = typeof showAllOverride === 'boolean' ? showAllOverride : switchShowAllZones;

                if (shouldShowAllZones && referenceCtx && referenceCanvas) {
                    referenceCtx.clearRect(0, 0, referenceCanvas.width, referenceCanvas.height);

                    if (!isGeoView) {
                        listZones
                            .filter((zone: any) => zone?.id !== -1)
                            .forEach((zone: any) => {
                                const emphasis = 0.5;
                                drawZonePolygon(referenceCtx, referenceCanvas, zone, emphasis);
                            });
                    }
                } else if (referenceCtx && referenceCanvas) {
                    referenceCtx.clearRect(0, 0, referenceCanvas.width, referenceCanvas.height);
                }

                if (!isEditingStaticCanvas) {
                    zoneCtx.clearRect(0, 0, canvas.width, canvas.height);

                    if (!isGeoView) {
                        const zonesToRender = selectedZoneData ? [selectedZoneData] : [];
                        const zoneAlpha = 0.8 //shouldShowAllZones ? 0.8 : 0.5;

                        zonesToRender
                            .filter((zone: any) => zone?.id !== -1)
                            .forEach((zone: any) => {
                                drawZonePolygon(zoneCtx, canvas, zone, zoneAlpha);
                            });
                    }
                }

                setLoading(false);
            } catch (error: any) {
                if (error instanceof InteractionRequiredAuthError) {
                    instance.acquireTokenRedirect(accessTokenRequest);
                }
                console.log(error);
                setLoading(false);
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            await commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest)
                .then((accessTokenResponse: any) => {
                    let accessToken = accessTokenResponse.accessToken;
                    return commonOperations(accessToken);
                })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                });
        }
    }

    const onToggleGeoStatic = async (e: any) => {

        const toggleValue: any = e.value;
        localStorage.setItem('onToggleGeoStatic', JSON.stringify(toggleValue));
        const mapSupportsGeo = isMapGeoreferencedFlag(selectedMap?.georeferenced);
        const shouldShowGeo = Boolean(mapSupportsGeo && toggleValue);
        localStorage.setItem('mapGeoreferenced', JSON.stringify(shouldShowGeo));
        setMapGeoreferenced(shouldShowGeo);
        setToggleGeoStatic(toggleValue);

        if (selectedMap) {
            await renderMap(selectedMap);
        }

        if (toggleValue) {
            if (selectedMap?.name) {
                await changeMap(selectedMap.name, undefined, Boolean(selectedZoneId ?? zoneSelected?.id));
            }
            return;
        }

        const currMapId = selectedMap?.id;
        if (currMapId) {
            await getZoneByMapId(currMapId, false, selectedMap);
        }

        if (zoneSelected?.id) {
            await getSelectedZone(zoneSelected);
        }

        setMode('polygon');
        requestAnimationFrame(() => {
            polygonRef.current?.reenterEditMode?.();
        });
    }

    const getMapByZoneId = async (zoneId: any, isGeo?: boolean) => {

        if (!zoneId) {
            return null;
        }

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            try {
                const res = await axios.get(`${SERVER_URL}/map/zone/${zoneId}`, { headers });
                const data = res?.data?.data;

                if (!data) {
                    return null;
                }

                const normalizedGeoFlag = isGeo != null ? isGeo : isMapGeoreferencedFlag(data?.georeferenced);
                const shouldShowGeo = Boolean(isMapGeoreferencedFlag(normalizedGeoFlag) && getStoredGeoTogglePreference());
                setMapGeoreferenced(shouldShowGeo);
                localStorage.setItem('mapGeoreferenced', JSON.stringify(shouldShowGeo));
                setMapName(data.name);
                setSelectedMap(data);
                if (data?.id) {
                    localStorage.setItem('mapId', `${data.id}`);
                }

                await renderMap(data);

                return data;
            } catch (data: any) {
                setError(data?.message);

                setTimeout(() => {
                    setError(false);
                }, 3000);
                return null;
            }
        }

        try {
            if (localStorage.getItem('accessToken') != null) {
                let accessToken = localStorage.getItem('accessToken');
                return await commonOperations(accessToken);
            } else {
                await instance.initialize();
                const accessTokenResponse: any = await instance.acquireTokenSilent(accessTokenRequest);
                let accessToken = accessTokenResponse.accessToken;
                return await commonOperations(accessToken);
            }
        } catch (error: any) {
            if (error instanceof InteractionRequiredAuthError) {
                instance.acquireTokenRedirect(accessTokenRequest);
            }
            return null;
        } finally {
            setLoading(false);
        }
    }

    const deleteZone = async (zoneId: any) => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            try {
                await axios.delete(`${SERVER_URL}/zone/${zoneId}`, { headers })
                setZoneName('');
                handleChangeZoneName({ target: { value: '' } })
                handleChangeColor({ value: '#ffffff' })
                setValueColor('#ffffff')
                setUpdateZone(false)
                await getZonesList(true);

                setMessageDeletedZone(true);
                if (!messageDeletedZone) {
                    setTimeout(() => {
                        setMessageDeletedZone(false);
                    }, 3000);
                }

            } catch (error: any) {
                setError(error);
                const errorMessage = error?.response?.data?.errorMessage || error?.message || 'An error occurred';
                if (errorMessage.includes('subscription inconsistency')) {
                    setErrorMessage(localizationService.toLanguageString('configuration.zones.delete_error_subscription_inconsistency', 'NOT FOUND'));
                } else {
                    setErrorMessage(errorMessage);
                }
                if (error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
                setLoading(false)
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            await commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                await commonOperations(accessToken)
            })
        }
    }

    useEffect(() => {
        if (!selectedMap?.id) {
            return;
        }
        void getZoneByMapId(selectedMap.id, mapGeoreferenced, selectedMap);
    }, [switchShowAllZones])

    const bolderStyles = `
        .config-zone-root {
            gap: 12px;
            align-items: stretch;
            padding: 10px;
        }

        .config-zone-left-panel {
            border: 1px solid #d6e8ee;
            border-radius: 14px;
            box-shadow: 0 10px 24px rgba(10, 55, 75, 0.08);
        }

        .config-zone-title {
            font-weight: 800;
            letter-spacing: 0.4px;
            text-shadow: 0 1px 0 rgba(255, 255, 255, 0.7);
        }

        .config-zone-item {
            background: #ffffff;
            border: 1px solid #cfe3ea;
            border-radius: 12px;
            padding: 6px 8px;
            box-shadow: 0 3px 10px rgba(10, 55, 75, 0.06);
            transition: transform 120ms ease, box-shadow 180ms ease;
        }

        .config-zone-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 8px 18px rgba(10, 55, 75, 0.12);
        }
    `;

    return (
        <div className="flex-parent-element config-zone-root" style={{ overflowX: 'hidden' }}>
            <style>{bolderStyles}</style>
            {loading && loadingPanel}
            <NotificationGroup
                style={{
                    right: 0,
                    bottom: 0,
                    position: "absolute",
                    alignItems: "flex-start",
                    flexWrap: "wrap-reverse",
                }}
            >
                <Fade enter={true} exit={true}>
                    {messageEditEnabled && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            onClose={() => setMessageEditEnabled(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.zones.messageEditEnabled', 'NOT_FOUND')}</span>
                        </Notification>
                    )}
                    {messageDeletedZone && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            onClose={() => setMessageDeletedZone(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.zones.deleted', 'NOT_FOUND')}</span>
                        </Notification>
                    )}

                    {error && (
                        <Notification
                            type={{ style: "error", icon: true }}
                            onClose={() => setErrorMessage(false)}
                        >
                            {
                                errorMessage
                                    ?
                                    <span>{errorMessage}</span>
                                    :
                                    <span>{localizationService.toLanguageString('configuration.zones.no_map_with_zone', 'NOT FOUND')}</span>
                            }
                        </Notification>
                    )}
                </Fade>
            </NotificationGroup>

            {/*zone list*/}
            <div
                className="config-zone-left-panel"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '10px',
                    background: '#F7F7F7',
                    flex: '1.5 1 0px',
                    overflowY: 'hidden',
                }}
            >
                <div style={{ textAlign: 'center', marginBottom: '10px', justifyContent: 'space-between' }}>

                    <p className="config-zone-title" style={{ display: 'inline-flex', textAlign: 'center', fontSize: '20px', color: '#1A8893' }}>
                        {localizationService.toLanguageString('configuration.zones.title', 'NOT_FOUND')} ({normalizedZoneSearch ? filteredZonesList.length : count})
                    </p>
                    <Button
                        title={localizationService.toLanguageString('configuration.zones.new', 'NOT_FOUND')}
                        themeColor={"primary"}
                        className="plusParam"
                        style={{
                            marginRight: '10px',
                            marginTop: '0px',
                            borderRadius: '10px',
                            //boxShadow: '0 3px 10px rgba(26,136,147,0.28)'
                        }}
                        onClick={() => {
                            previousSelectedZoneIdRef.current = lastSelectedZoneIdRef.current ?? selectedZoneId ?? zoneSelected?.id ?? null
                            selectionLockZoneIdRef.current = previousSelectedZoneIdRef.current;
                            setUpdateZone(false)
                            handleChangeZoneName({ target: { value: '' } })
                            handleChangeColor({ value: '#ffffff' })
                            setValueColor('#ffffff')
                            setAltitude(0)
                            setShowLimitCapacity(false)
                            setLimitCapacity(0)
                            setLocationZone(true)
                            setInternal(false)
                            setSwitchShowAllZones(false)
                            setCurrZonePoints(0)
                            setPolygonPoints([])
                            setPolygonReady(false)
                            setPrefillPolygonVersion((prev) => prev + 1)
                            resetMapSelectionForNewZone()
                            setMode('polygon')

                        }}
                        disabled={userType === 'StandardOnlyLocator'}
                    >
                        <Avatar
                            className="plusParam"
                        >
                            <SvgIcon
                                icon={plusIcon}
                                style={{ margin: '8px' }}
                            />
                        </Avatar>
                    </Button>
                </div>

                <div style={{ padding: '0 8px 8px 8px' }}>
                    <TextBox
                        value={zoneSearchTerm}
                        onChange={(event: any) => setZoneSearchTerm(event.target.value ?? '')}
                        placeholder={`${localizationService.toLanguageString('search', 'Search')}...`}
                        style={{ width: '100%' }}
                    />
                </div>

                <div
                    className="flex-left-child-element"
                    style={{
                        flex: 1,
                        minHeight: 0,
                        padding: '8px',
                        overflowY: 'auto',
                        width: '100%',
                    }}
                >
                    {filteredZonesList?.map((zone: any, index: any) => {
                        return (
                            zone.id != -1 &&
                            <div
                                key={index}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    marginBottom: '6px',
                                }}
                            >

                                {/*delete zone button*/}
                                <div
                                    className="trash-icon"
                                    title={localizationService.toLanguageString('configuration.zones.delete', 'NOT_FOUND')}
                                    style={{
                                        cursor: 'pointer',
                                        alignContent: 'center',
                                        pointerEvents: `${userType === 'StandardOnlyLocator' ? 'none' : 'auto'}`,
                                        opacity: `${userType === 'StandardOnlyLocator' ? 0.5 : 1}`
                                    }}
                                    onClick={() => {
                                        deleteZone(zone.id)
                                    }}
                                >
                                    <Avatar
                                        className="trash-icon"
                                    >
                                        <SvgIcon
                                            icon={trashIcon}
                                            style={{ verticalAlign: 'baseline', margin: '10px' }}
                                        />
                                    </Avatar>
                                </div>

                                {/*clone zone button*/}
                                <div
                                    className="trash-icon"
                                    style={{
                                        cursor: 'pointer',
                                        alignContent: 'center',
                                        marginRight: '10px',
                                        pointerEvents: `${userType === 'StandardOnlyLocator' ? 'none' : 'auto'}`,
                                        opacity: `${userType === 'StandardOnlyLocator' ? 0.5 : 1}`
                                    }}
                                    onClick={() => {
                                        cloneZone(zone.id)
                                    }}
                                    title={localizationService.toLanguageString('configuration.zones.clone', 'NOT_FOUND')}
                                >
                                    <Avatar
                                        className="trash-icon"
                                    >
                                        <SvgIcon
                                            icon={copyIcon}
                                            style={{ verticalAlign: 'baseline', margin: '10px' }}
                                        />
                                    </Avatar>
                                </div>

                                {/*select zone*/}
                                <div
                                    style={{ display: 'inline-flex', alignItems: 'center', flex: 1, }}
                                >
                                    <p
                                        style={{
                                            border: `1px solid ${(zone?.color == '#ffffff' || zone?.color == '#NaN') ? 'black' : zone?.color}`,
                                            borderRadius: '30px',
                                            width: '18px',
                                            height: '18px',
                                            marginTop: '10px',
                                            background: `${zone?.color}`
                                        }}
                                    ></p>
                                    <p
                                        className="config-zone-item"
                                        style={{
                                            cursor: 'pointer',
                                            marginLeft: '10px',
                                            marginBottom: '0px',
                                            padding: '10px',
                                            flex: 1,
                                            color: selectedZoneId == zone.id ? '#ffffff' : 'inherit',
                                            background: selectedZoneId == zone.id ? '#198792' : '#ffffff',
                                            fontSize: 'clamp(11px, 0.7vw, 16px)'
                                        }}
                                        onClick={() => {
                                            setSelectedZoneId(zone?.id ?? null);
                                            void getSelectedZone(zone)
                                        }}
                                    >
                                        {`${zone?.id ?? ''}  : ${zone?.name}`}
                                    </p>
                                </div>
                            </div>
                        )
                    })}
                    {filteredZonesList.length === 0 && (
                        <p style={{ textAlign: 'center', color: '#5d7278', marginTop: '12px' }}>
                            {localizationService.toLanguageString('zone.no_value', 'No data available to show')}
                        </p>
                    )}
                </div>

            </div>

            {/*zone configuration*/}
            <div
                className="flex-right-child-element"
                style={{
                    paddingTop: "0px",
                    paddingRight: "10px",
                    paddingLeft: "5px",
                    overflowY: "auto",
                }}
            >
                <ExpansionPanel
                    title={localizationService.toLanguageString('configuration.zones.details', 'Details')}
                    expanded={detailsExpanded}
                    onAction={() => setDetailsExpanded(!detailsExpanded)}
                    style={{
                        background: '#ffffff',
                        borderRadius: '10px',
                        border: '1px solid #cfe3ea',
                        marginBottom: '16px'
                    }}
                >
                    {detailsExpanded && (
                        <ExpansionPanelContent>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                height: 'auto',
                                minHeight: '200px',
                                alignItems: 'flex-start',
                            }
                            }>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '10px'
                                    }}>
                                    {/* Colonna sinistra */}
                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>

                                        <p style={{ fontSize: '16px', color: '#1A8893', margin: '10px 6px 0 0' }}>
                                            {localizationService.toLanguageString('configuration.zones.name', 'NOT_FOUND')}
                                        </p>

                                        <TextBox
                                            style={{ width: "235px" }}
                                            value={zoneName}
                                            onChange={handleChangeZoneName}
                                            placeholder=''
                                            disabled={userType === 'StandardOnlyLocator'}
                                        />

                                        {!updateZone ? (
                                            <Button
                                                title={localizationService.toLanguageString('configuration.zones.save', 'NOT_FOUND')}
                                                themeColor={"primary"}
                                                className="saveParam"
                                                disabled={zoneName === '' || !polygonReady || !selectedMap?.id || userType === 'StandardOnlyLocator'}
                                                onClick={() => saveNewZone()}
                                            >
                                                <Avatar className="saveParam">
                                                    <SvgIcon icon={saveIcon} style={{ margin: '8px' }} />
                                                </Avatar>
                                            </Button>
                                        ) : (
                                            <Button
                                                title={localizationService.toLanguageString('configuration.zones.update', 'NOT_FOUND')}
                                                themeColor={"primary"}
                                                className="saveParam"
                                                onClick={() => updateSelectedZone(zonesInfo[0].id)}
                                                disabled={userType === 'StandardOnlyLocator'}
                                            >
                                                <Avatar className="saveParam">
                                                    <SvgIcon icon={saveIcon} style={{ margin: '8px' }} />
                                                </Avatar>
                                            </Button>
                                        )}
                                    </div>

                                    {/* map list */}
                                    <div style={{ display: 'flex', margin: '20px 0 0 0px', alignItems: 'baseline' }}>
                                        <p style={{ width: "60px", color: '#018CA5' }}>{localizationService.toLanguageString('configuration.zones.maps', 'NOT_FOUND')}</p>
                                        <DropDownList
                                            data={listMapNames}
                                            value={mapName}
                                            defaultItem={localizationService.toLanguageString('map.select_map', 'NOT_FOUND')}
                                            onChange={(e: any) => {
                                                const keepCurrentSelection = previousSelectedZoneIdRef.current != null || selectedZoneId != null || zoneSelected?.id != null;
                                                void changeMap(e, undefined, keepCurrentSelection);
                                            }}
                                            style={{ width: "235px", height: "40px", color: '#018CA5', cursor: 'pointer' }}
                                            title={localizationService.toLanguageString('map.select_map', 'NOT_FOUND')}
                                            disabled={userType === 'StandardOnlyLocator'}
                                        />

                                        {/*toggleGeoStatic*/}
                                        {selectedMap?.georeferenced == 1 && selectedMap?.image != '' &&
                                            <div style={{ width: '130px', marginLeft: '15px' }}>
                                                <Switch
                                                    onChange={onToggleGeoStatic}
                                                    checked={toggleGeoStatic}
                                                    disabled={userType === 'StandardOnlyLocator'}
                                                />
                                                <label
                                                    style={{ margin: '0 auto', fontSize: 'clamp(11px, 0.7vw, 16px)' }}
                                                    className="k-ml-3"
                                                >
                                                    {toggleGeoStatic ?
                                                        localizationService.toLanguageString('map.geo', 'NOT_FOUND')
                                                        :
                                                        localizationService.toLanguageString('map.static', 'NOT_FOUND')
                                                    }
                                                </label>
                                            </div>
                                        }
                                    </div>

                                    {/*show all zones*/}
                                    <div className="k-mb-2" style={{ marginLeft: '60px' }}>
                                        <Switch
                                            checked={switchShowAllZones}
                                            onChange={() => {
                                                setSwitchShowAllZones(!switchShowAllZones);
                                            }}
                                        />
                                        <label className="k-ml-3">{localizationService.toLanguageString('configuration.zones.showAll', 'NOT_FOUND')}</label>

                                        <span
                                            className="k-icon k-font-icon k-i-palette"
                                            style={{
                                                width: '0px',
                                                height: '0px',
                                                fontSize: 'x-large',
                                                cursor: 'pointer',
                                                background: `${valueColor}`,
                                                border: '1px solid #bdc4cb',
                                                borderRadius: '30px',
                                                padding: '20px',
                                                marginLeft: '10px',
                                                pointerEvents: `${userType === 'StandardOnlyLocator' ? 'none' : 'auto'}`,
                                                opacity: `${userType === 'StandardOnlyLocator' ? 0.5 : 1}`
                                            }}
                                            onClick={showColorPicker}
                                        />

                                    </div>

                                </div>


                                {/* Popup con switch tutto a destra */}
                                <div style={{
                                    display: "flex",
                                    boxShadow: '0px 0px 10px #19838F',
                                    borderRadius: '10px',
                                    padding: 10,
                                    flexDirection: "column",
                                    fontSize: 'clamp(11px, 0.7vw, 16px)',
                                    flexGrow: 0.1
                                }}>
                                    {/*altitude and points*/}
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: `${selectedMap?.georeferenced == 1 ? '15px' : '70px'}`
                                        }}
                                    >
                                        <label>
                                            {localizationService.toLanguageString('configuration.zones.altitude', 'NOT_FOUND')}: {altitude}
                                        </label>

                                        <label>
                                            {localizationService.toLanguageString('configuration.zones.points', 'NOT_FOUND')}: {currZonePoints}
                                        </label>
                                    </div>

                                    {/*internal and locationZone*/}
                                    <div
                                        style={{
                                            display: "flex"
                                        }}
                                    >
                                        <div style={{ width: '130px' }}>
                                            <Switch
                                                checked={internal}
                                                onChange={() => setInternal(!internal)}
                                                disabled={userType === 'StandardOnlyLocator'}
                                                size="small"
                                            />
                                            <label style={{ marginLeft: '5px' }}>
                                                {localizationService.toLanguageString('configuration.zones.internal', 'NOT_FOUND')}
                                            </label>
                                        </div>


                                        <div>
                                            <Switch
                                                checked={locationZone}
                                                onChange={() => setLocationZone(!locationZone)}
                                                disabled={userType === 'StandardOnlyLocator'}
                                                size="small"
                                            />
                                            <label style={{ marginLeft: '5px' }}>
                                                {localizationService.toLanguageString('configuration.zones.locationZone', 'NOT_FOUND')}
                                            </label>
                                        </div>
                                    </div>

                                    {/*limit capacity & isGeo */}
                                    <div style={{
                                        display: "flex",
                                    }}>
                                        <div style={{ width: '130px' }}>
                                            <Switch
                                                checked={showLimitCapacity}
                                                onChange={() => setShowLimitCapacity(!showLimitCapacity)}
                                                disabled={userType === 'StandardOnlyLocator'}
                                                size="small"
                                            />
                                            <label style={{ marginLeft: '5px' }}>
                                                {localizationService.toLanguageString('configuration.zones.limitCapacity', 'NOT_FOUND')}
                                            </label>

                                            {showLimitCapacity && (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        gap: '5px',
                                                        height: '30px',
                                                        marginTop: '5px',
                                                    }}
                                                >
                                                    <p style={{ fontSize: '14px', color: '#1A8893' }}>
                                                        {localizationService.toLanguageString('configuration.zones.capacity', 'NOT_FOUND')}
                                                    </p>
                                                    <NumericTextBox
                                                        style={{ width: "82px" }}
                                                        defaultValue={0}
                                                        value={limitCapacity}
                                                        onChange={(e: any) => setLimitCapacity(e.target.value)}
                                                        max={100}
                                                        placeholder=''
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        <div>
                                            <Switch
                                                checked={isGeo}
                                                onChange={() => setIsGeo(!isGeo)}
                                                disabled={userType === 'StandardOnlyLocator'}
                                                size="small"
                                            />
                                            <label style={{ marginLeft: '5px' }}>
                                                {localizationService.toLanguageString('configuration.zones.geo', 'NOT_FOUND')}
                                            </label>

                                        </div>

                                    </div>

                                </div>

                            </div>
                        </ExpansionPanelContent>
                    )}
                </ExpansionPanel>


                {/*maps*/}
                <div>
                    {/*static map*/}
                    <div
                        ref={mapRefStatic}
                        style={{
                            height: '650px',
                            marginBottom: '10px',
                            display: mapGeoreferenced ? 'none' : 'flex',
                            boxShadow: '0px 0px 10px #19838F',
                            borderRadius: '10px',
                            zIndex: 999
                        }}
                    >
                        <div style={{
                            marginTop: '1px',
                            paddingLeft: '5px',
                            flexDirection: 'column',
                            display: 'flex',
                            marginRight: '25px'
                        }}
                        >
                            <button
                                className="k-button static-map"
                                onClick={() => resetZoneDrawing()}
                                title={localizationService.toLanguageString('configuration.zones.reset', 'NOT_FOUND')}
                                disabled={userType === 'StandardOnlyLocator'}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="27" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.76 2.75L3 8" />
                                    <path d="M3 3v5h5" />
                                </svg>
                            </button>
                            <button
                                className="k-button static-map"
                                onClick={() => {
                                    setMode('polygon')
                                    setMessageEditEnabled(true)
                                }}
                                title={localizationService.toLanguageString('configuration.zones.edit', 'NOT_FOUND')}
                                disabled={userType === 'StandardOnlyLocator'}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="27" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                                </svg>
                            </button>
                            <button
                                className="k-button static-map"
                                onClick={() => {
                                    pendingAddVertexRef.current = true;

                                    if (mode === 'polygon' && polygonRef.current) {
                                        polygonRef.current.enterAddVertexMode();
                                        pendingAddVertexRef.current = false;
                                        return;
                                    }

                                    setMode('polygon');
                                }}
                                title={localizationService.toLanguageString('configuration.zones.addVertex', 'NOT_FOUND')}
                                disabled={userType === 'StandardOnlyLocator'}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="27" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M17 3a2.85 2.85 0 0 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
                                    <path d="M15 5l4 4" />
                                </svg>
                            </button>
                        </div>

                        <TransformWrapper
                            initialScale={0.5}
                            initialPositionX={0}
                            initialPositionY={0}
                            minScale={0.3}
                            centerOnInit
                            centerZoomedOut={false}
                            limitToBounds
                            smooth={true}
                            doubleClick={{
                                disabled: true
                            }}
                            panning={{
                                disabled: !allowStaticMapPan
                            }}
                            wheel={{
                                disabled: !allowStaticMapPan
                            }}
                        >
                            {({ zoomIn, zoomOut, resetTransform, centerView, zoomToElement, ...rest }) => (
                                <>
                                    <Controls />
                                    {noMaps &&
                                        // Mostra un messaggio o un altro contenuto se non ci sono dati
                                        <div style={{ textAlign: 'center', padding: '20px' }}>
                                            <p>{localizationService.toLanguageString('map.no_map', 'NOT_FOUND')}</p>
                                        </div>
                                    }

                                    <TransformComponent
                                        wrapperStyle={{
                                            width: '100%',
                                            height: '100%',
                                            borderRadius: '20px'
                                        }}
                                        contentStyle={{
                                            width: mapImageWidth,
                                            height: mapImageHeight,
                                            position: 'relative',
                                        }}
                                    >
                                        <div>
                                            <canvas
                                                ref={mapCanvas}
                                                className="mapCanvasConfigZones"
                                                width={1400}
                                                height={2000}
                                            />
                                            <canvas
                                                ref={referenceZonesCanvas}
                                                className="referenceZonesCanvasConfigZones"
                                                width={1400}
                                                height={2000}
                                            />
                                            <canvas
                                                ref={zoneCanvas}
                                                className="zoneCanvasConfigZones"
                                                width={1400}
                                                height={2000}
                                            />
                                        </div>
                                    </TransformComponent>
                                </>
                            )}
                        </TransformWrapper>
                    </div>

                    {contextMenu.visible && contextMenu.vertexIndex !== null && (
                        <div
                            style={{
                                position: 'fixed',
                                top: contextMenu.y,
                                left: contextMenu.x,
                                backgroundColor: 'transparent',
                                zIndex: 1000,
                            }}
                            title={localizationService.toLanguageString('configuration.zones.delete', 'NOT_FOUND')}
                            onClick={() => {
                                removeVertex();
                                setContextMenu({ visible: false, x: 0, y: 0, vertexIndex: null });
                            }}
                        >
                            <SvgIcon
                                icon={trashIcon}
                                style={{ width: '24px', height: '24px', color: '#1A8490', cursor: 'pointer' }}
                            />
                        </div>
                    )}

                    {/*AzureMapComponent*/}
                    <div
                        ref={mapRefAzure}
                        style={{
                            height: '650px',
                            marginBottom: '10px',
                            boxShadow: '0px 0px 10px #19838F',
                            borderRadius: '10px',
                            display: !mapGeoreferenced ? 'none' : 'block'
                        }}
                    >
                        {listMaps.length != 0 && mapGeoreferenced &&
                            <AzureMapComponent
                                map={selectedMap ?? localStorage.getItem('mapSelected')}
                                zones={zoneSelected ?? []}
                                referenceZones={mapGeoreferenced && switchShowAllZones ? mapZones : []}
                                showReferenceZones={Boolean(mapGeoreferenced && switchShowAllZones)}
                                geoStaticToggle={toggleGeoStatic}
                                configZone={userType === 'StandardOnlyLocator' ? false : true}
                                valueColor={valueColor}
                                onPolygonVerticesChange={handleAzurePolygonVertices}
                            />
                        }
                    </div>
                </div>

                {/*colorpicker*/}
                {
                    toggleColorPicker &&
                    <Dialog
                        className="no-padding-dialog"
                        onClose={() => setToggleColorPicker(false)}
                    >
                        <FlatColorPicker
                            value={valueColor}
                            format="hex"
                            onChange={handleChangeColor}
                        />
                    </Dialog>
                }

            </div>
        </div>
    );


};
